import React, { useEffect, useState } from "react";
import playstore from "../../assets/images/playstore-02.png";
import appstore from "../../assets/images/appstore2.png";
import aboutimg from "../../assets/images/about-img.png";
import { baseUrl } from "../../helper/axiosConfig";
import axios from "axios";
import MobileBottomBar from "../Layout/MobileBottomBar";

function AboutUs() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    // Scroll to top is now handled globally in Layout component
    fetchPolicy();
  }, []);

  const fetchPolicy = async () => {
    try {
      const res = await axios.get(`${baseUrl}/about-us`);

      setTitle(res.data.data.title);
      setDescription(res.data.data.description);
    } catch (error) {
    }
  };


  return (
    <>
      {/* Modern Hero Section */}
      <section className="modern-hero-section">
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">{title || "About Fynito"}</h1>
            <p className="hero-subtitle">
              Your trusted food delivery partner, bringing delicious meals right to your doorstep
            </p>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="modern-about-section">
        <div className="container">
          <div className="row align-items-center">
            {/* Image Column */}
            <div className="col-lg-6 col-md-6 mb-4 mb-lg-0">
              <div className="about-image-container">
                <img src={aboutimg} className="about-image" alt="About Fynito" />
                <div className="image-decoration"></div>
              </div>
            </div>

            {/* Content Column */}
            <div className="col-lg-6 col-md-6">
              <div className="about-content">
                <div className="content-card">
                  <h2 className="section-title">Who We Are</h2>
                  <p className="content-text">
                    Fynito is your go-to food delivery partner, bringing your
                    favorite meals from top local restaurants right to your
                    doorstep—fast, fresh, and fuss-free. Built with passion by PGR
                    Technologies, Fynito is more than just a food delivery app; it's
                    a smart ecosystem designed to streamline food ordering for
                    customers, restaurants, and delivery partners.
                  </p>
                </div>

                <div className="content-card">
                  <h3 className="card-title">Our Mission</h3>
                  <p className="content-text">
                    At Fynito, we believe good food should be just a few taps away.
                    Whether you're craving street-style snacks or gourmet cuisine,
                    we connect you with a wide variety of restaurants across your
                    city. Our user-friendly platform ensures a seamless ordering
                    experience, real-time order tracking, and secure online
                    payments.
                  </p>
                </div>

                <div className="content-card highlight-card">
                  <h3 className="card-title">What Makes Us Different?</h3>
                  <p className="content-text">
                    We go beyond delivery. Our platform integrates directly with
                    restaurant POS systems like Petpooja, enabling real-time order
                    syncing and smooth operations for our restaurant partners. We're
                    also simplifying onboarding through automated location and
                    business info retrieval, helping new vendors get started
                    effortlessly.
                  </p>
                </div>

                <div className="content-card">
                  <p className="content-text">
                    Whether you're a hungry customer, a growing restaurant, or a
                    delivery executive, Fynito is here to empower you with
                    technology that works—reliably, efficiently, and transparently.
                  </p>
                  <p className="tagline">Fynito – Fast food. Smart delivery.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Download Section */}
      <section className="modern-download-section">
        <div className="container">
          <div className="download-container">
            <div className="download-content">
              <h2 className="download-title">Download Our App</h2>
              <p className="download-subtitle">
                Get the best food delivery experience on your mobile device
              </p>
              <div className="download-buttons">
                <a
                  href="https://play.google.com/store/apps/details?id=com.fynito.user&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-btn playstore-btn"
                >
                  <img src={playstore} alt="Download on Google Play" />
                </a>
                <a
                  href="https://apps.apple.com/in/app/fynito/id6739328008"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-btn appstore-btn"
                >
                  <img src={appstore} alt="Download on App Store" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Bottom Bar */}
      <MobileBottomBar />
    </>
  );
}

export default AboutUs;
